import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextFieldComponent } from './text-field/text-field.component';
import { NgxMaskModule } from 'ngx-mask';
import { ErrorMessageModule } from '@app/theme/error-message/error-message.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { AutoCompleteTextFieldComponent } from './auto-complete-text-field/auto-complete-text-field.component';

@NgModule({
  declarations: [TextFieldComponent, AutoCompleteTextFieldComponent],
  imports: [
    CommonModule,
    NgxMaskModule.forRoot(),
    ErrorMessageModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteLibModule,
  ],
  exports: [TextFieldComponent, AutoCompleteTextFieldComponent],
})
export class TextFieldModule {}
